export type ColorFamily = 'red' | 'yellow' | 'blue' | 'green' | 'neutral';

const catalog = {
  Status: {ACTIVE: 'red', RELEASED: 'neutral'},
  CommandStatus: {PENDING: 'yellow', SENT: 'blue', CONFIRMED: 'green', DISCARDED: 'neutral', NOT_SUPPORTED: 'red'},
  ReleaseReason: {
    PAYMENT: 'neutral', CANCELLED: 'neutral', MANUAL: 'neutral',
    OPTION_DISABLED: 'neutral', CUSTOMER_CHANGED: 'neutral', EXEMPTION: 'neutral',
  },
  ReleaseCommandStatus: {SENT: 'blue', CONFIRMED: 'green', NO_CONFIRMATION: 'yellow'},
  DispatchType: {BLOCK_COMMAND: 'neutral', RELEASE_COMMAND: 'neutral'},
  DispatchResult: {
    SENT: 'blue', CONFIRMED: 'green', UNCONFIRMED: 'yellow', NO_CONFIRMATION: 'yellow',
    PENDING: 'yellow', DISCARDED: 'neutral', NOT_SUPPORTED: 'red', FAILED: 'red',
  },
  RunStatus: {RUNNING: 'blue', COMPLETED: 'green', FAILED: 'red', MISSED: 'red'},
} as const;

export type EnumName = keyof typeof catalog;

const familyOf = (enumName: EnumName, value: string): ColorFamily | undefined => (
  (catalog[enumName] as Record<string, ColorFamily>)[value]
);

const pascal = (value: string) => value.toLowerCase().replace(/(^|_)([a-z])/g, (_, __, letter) => letter.toUpperCase());

export const labelId = (enumName: EnumName, value: string) => (
  familyOf(enumName, value) ? `billingBlock${enumName}${pascal(value)}` : undefined
);

export const colorFamily = (enumName: EnumName, value: string): ColorFamily => familyOf(enumName, value) || 'neutral';
